<template>
    <div class="section-details-black">
        <div class="container-xxl padding-container-matrix">
           <div class="row justify-content-center">
               <div class="col-matrix">
                   <div class="row">
                       <div class="col-12 col-lg-6 mb-5 mb-lg-0">
                           <h5 class="text-weight-semibold ">{{sectionBlock.sectionTitle}}</h5>
                       </div>
                       <div class="col-12 col-lg-6">
                            <div
                                v-for="(section, index) in sectionBlock.sectionBlockText"
                                :key="'section-text-' + index"
                                class="section-text"
                            >

                               <div class="text-editor" v-html="section.sectionText"></div>
                            </div>
                        </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'sectionDetailsBlack',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
